/* eslint-env browser, amd */

import SDK from 'bam-browser-sdk'; //eslint-disable-line import/no-extraneous-dependencies
import sdkSessionUtil from 'bam-browser-sdk-sdkSession-util'; //eslint-disable-line import/no-extraneous-dependencies
import pageMeta from 'btm-pageMeta/pageMeta'; //eslint-disable-line import/no-unresolved, import/extensions
import disneyOneIdWrapper from 'disneyOneIdWrapper'; //eslint-disable-line import/no-unresolved, import/extensions
import device from 'device/device'; //eslint-disable-line import/no-unresolved, import/extensions
import user from 'btm-user-manager'; //eslint-disable-line import/no-extraneous-dependencies
import getLocation from '../scripts/getLocation';
import geoHelper from '../scripts/geoHelper';


const isIE = device().is.msie;
const version = parseInt(device().browserVersion, 10);
const isFireFox = device().is.firefox;

if (isIE && version === 11) {
    document.body.classList.add('isIE');
}

if (isFireFox) {
    document.body.classList.add('firefox');
}

const exceptionReference = SDK.Services.Exception.ExceptionReference;
const authenticationExpired = exceptionReference.common.authenticationExpired;

function isExpired(timestamp) {
    const expirationTime = new Date(timestamp);
    const currentTime = new Date();
    return currentTime > expirationTime;
}

function handleExpiredBtmToken() {
    return disneyOneIdWrapper.disneyIdService.getGuest()
        .then((guest) => {
            const token = guest.token && guest.token.id_token ? guest.token.id_token : '';
            const swid = guest.profile && guest.profile.swid ? guest.profile.swid : '';

            if (token && swid && !isExpired(guest.token.expires)) {
                user.external.logout().then(() => {
                    user.external.login(token, swid);
                }).catch(disneyOneIdWrapper.handleBreachErrors);
            } else {
                disneyOneIdWrapper.forceTokenRefresh();
            }
        })
        .catch(() => {
            disneyOneIdWrapper.forceTokenRefresh();
        });
}

console.log('site-core: all devices');
const section = pageMeta.section;
const oneIdEnabled = JSON.parse(pageMeta.oneIdEnabled || false);

sdkSessionUtil.setBootstrapConfiguration(window.server_path.sdk);
user.external.setProvider('espn');

if (section !== 'video' && window.location.pathname.indexOf('denied') === -1) {
    getLocation()
        .then((location) => {
            return geoHelper.isUserInGeofence(location.countryCode);
        })
        .then((geoEnabled) => {
            if (!geoEnabled) {
                window.location.replace('/denied?block=geo');
            }
        })
        .catch((error) => {
            console.error(error);
        });
}

if (oneIdEnabled) {
    // Listen for token refresh failures, force OneID token refresh
    sdkSessionUtil.getSdkSession()
        .then((sdkSession) => {
            sdkSession.on('ReauthorizationFailure', (reauthorizationFailure) => {
                if (reauthorizationFailure &&
                    reauthorizationFailure.error &&
                    reauthorizationFailure.error.data &&
                    reauthorizationFailure.error.data.name === authenticationExpired.name) {
                    handleExpiredBtmToken();
                }
            });
        })
        .catch((error) => {
            console.error(error);
        });

    sdkSessionUtil.on('SdkSessionResetOnError', () => {
        handleExpiredBtmToken();
    });
}
